
import Windows from "../../../assets/filled/Windows.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function WindowsIcon({ className, dataTestid = "WindowsIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Windows data-testid={dataTestid} className={classes} {...rest} />
  );
}
